import { useAuthenticatedFetch } from './apiService';

// SPEECH TOKEN

export interface SpeechTokenResponse {
  token: string;
  region: string;
}

export const useSpeechTokenService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  const fetchSpeechToken = async (): Promise<SpeechTokenResponse> => {
    const res = await authenticatedFetch('/auth/speech-token');
    if (!res.ok) {
      throw new Error(`Failed to fetch speech token: ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    if (!data.token || !data.region) {
      throw new Error('Speech token response missing required fields');
    }
    return data;
  };

  return { fetchSpeechToken };
};

// ICE TOKEN FOR WEBRTC

export interface IceTokenResponse {
  iceServerUrl: string;
  iceServerUsername: string;
  iceServerCredential: string;
}

/**
 * React hook to get ICE token service functions.
 */
export const useIceTokenService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  /**
   * Fetches ICE token (credentials) from backend using authenticated request.
   */
  const fetchIceToken = async (): Promise<IceTokenResponse> => {
    const res = await authenticatedFetch('/auth/ice-token');
    if (!res.ok) {
      throw new Error(`Failed to fetch ICE token: ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    if (!data.iceServerUrl || !data.iceServerUsername || !data.iceServerCredential) {
      throw new Error('ICE token response missing required fields');
    }
    return data;
  };

  return { fetchIceToken };
};